import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
export function Footer() {
  const currentYear = new Date().getFullYear();
  const {
    t
  } = useLanguage();
  return <footer className="bg-white pt-24 pb-12 border-t border-black/5" data-id="element-15">
      <div className="container mx-auto px-6 md:px-12" data-id="element-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-16" data-id="element-17">
          {/* Brand */}
          <div className="md:col-span-1" data-id="element-18">
            <Link to="/" className="block mb-6" aria-label="Paola Skin Lab — Home" data-id="element-19">
              <img src="https://cdn.magicpatterns.com/uploads/qQKPnKJWGF9W8Gg3kVEgXQ/WhatsApp_Image_2026-05-06_at_11.41.55_PM.jpg" alt="Paola Skin Lab" className="h-16 w-auto object-contain" data-id="element-20" />
            </Link>
            <p className="text-sm text-black/60 leading-relaxed max-w-xs" data-id="element-21">
              {t('footer.tagline')}
            </p>
          </div>

          {/* Contact */}
          <div data-id="element-22">
            <h4 className="text-xs font-semibold tracking-[0.2em] uppercase text-gold mb-6" data-id="element-23">
              {t('footer.contactHeading')}
            </h4>
            <ul className="space-y-3 text-sm text-black/70" data-id="element-24">
              <li data-id="element-25">
                <a href="mailto:sales@paolaskinlab.com" className="hover:text-gold transition-colors" data-id="element-26">
                  sales@paolaskinlab.com
                </a>
              </li>
              <li data-id="element-27">
                <a href="tel:7863763985" className="hover:text-gold transition-colors" data-id="element-28">
                  786-376-3985
                </a>
              </li>
            </ul>
          </div>

          {/* Navigation */}
          <div data-id="element-29">
            <h4 className="text-xs font-semibold tracking-[0.2em] uppercase text-gold mb-6" data-id="element-30">
              {t('footer.exploreHeading')}
            </h4>
            <ul className="space-y-3 text-sm text-black/70" data-id="element-31">
              <li data-id="element-32">
                <a href="/#about" className="hover:text-gold transition-colors" data-id="element-33">
                  {t('footer.links.about')}
                </a>
              </li>
              <li data-id="element-34">
                <a href="/#focus" className="hover:text-gold transition-colors" data-id="element-35">
                  {t('footer.links.focus')}
                </a>
              </li>
              <li data-id="element-36">
                <a href="/#why-us" className="hover:text-gold transition-colors" data-id="element-37">
                  {t('footer.links.whyUs')}
                </a>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div data-id="element-38">
            <h4 className="text-xs font-semibold tracking-[0.2em] uppercase text-gold mb-6" data-id="element-39">
              {t('footer.legalHeading')}
            </h4>
            <ul className="space-y-3 text-sm text-black/70" data-id="element-40">
              <li data-id="element-41">
                <Link to="/privacy-policy" className="hover:text-gold transition-colors" data-id="element-42">
                  {t('footer.links.privacy')}
                </Link>
              </li>
              <li data-id="element-43">
                <Link to="/terms-and-conditions" className="hover:text-gold transition-colors" data-id="element-44">
                  {t('footer.links.terms')}
                </Link>
              </li>
              <li data-id="element-45">
                <Link to="/disclaimer" className="hover:text-gold transition-colors" data-id="element-46">
                  {t('footer.links.disclaimer')}
                </Link>
              </li>
              <li data-id="element-47">
                <Link to="/refund-policy" className="hover:text-gold transition-colors" data-id="element-48">
                  {t('footer.links.refund')}
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom */}
        <div className="pt-8 border-t border-black/5 flex flex-col md:flex-row items-center justify-between gap-4" data-id="element-49">
          <p className="text-xs text-black/40 uppercase tracking-wider" data-id="element-50">
            &copy; {currentYear} {t('footer.rights')}
          </p>
          <p className="text-xs text-black/40 uppercase tracking-wider" data-id="element-51">
            {t('footer.informationalNote')}
          </p>
        </div>
      </div>
    </footer>;
}